import React from 'react';
import { Trash2, CheckCircle, XCircle } from 'lucide-react';

const AdminDashboard = ({ bookings, onDelete, onStatusChange }) => {
    return (
        <div className="glass-card p-6 h-full overflow-y-auto">
            <h2 className="text-xl font-poppins font-semibold text-white mb-6">Booking Management</h2>

            <div className="space-y-4">
                {bookings.length === 0 ? (
                    <p className="text-white/40 text-center py-8">No bookings scheduled yet.</p>
                ) : (
                    bookings.map(booking => (
                        <div key={booking.id} className="bg-white/5 border border-white/10 rounded-lg p-4 hover:border-accent/50 transition-colors">
                            <div className="flex justify-between items-start mb-2">
                                <div>
                                    <h3 className="font-medium text-white">{booking.title}</h3>
                                    <p className="text-sm text-white/60">
                                        {new Date(booking.start).toLocaleDateString()} at {new Date(booking.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </p>
                                </div>
                                <span className={`px-2 py-1 rounded text-xs ${booking.extendedProps?.status === 'confirmed' ? 'bg-green-500/20 text-green-400' :
                                        booking.extendedProps?.status === 'cancelled' ? 'bg-red-500/20 text-red-400' :
                                            'bg-yellow-500/20 text-yellow-400'
                                    }`}>
                                    {booking.extendedProps?.status || 'pending'}
                                </span>
                            </div>

                            <div className="flex gap-2 mt-3 justify-end">
                                <button
                                    onClick={() => onStatusChange(booking.id, 'confirmed')}
                                    className="p-1.5 hover:bg-green-500/20 rounded text-green-400 transition-colors"
                                    title="Confirm"
                                >
                                    <CheckCircle size={16} />
                                </button>
                                <button
                                    onClick={() => onStatusChange(booking.id, 'cancelled')}
                                    className="p-1.5 hover:bg-red-500/20 rounded text-red-400 transition-colors"
                                    title="Cancel"
                                >
                                    <XCircle size={16} />
                                </button>
                                <button
                                    onClick={() => onDelete(booking.id)}
                                    className="p-1.5 hover:bg-white/10 rounded text-white/60 hover:text-red-400 transition-colors"
                                    title="Delete"
                                >
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
